// Locale files for the `lab` messages, loaded at build time and keyed by locale.
// Adding a locale is dropping a `<locale>.json` in beside the others — no code change.
const localeModules = import.meta.glob("./lab/*.json", { eager: true });

const messages = {};
for (const path in localeModules) {
  const locale = path.match(/\.\/lab\/(.+)\.json$/)?.[1];
  if (locale) {
    messages[locale] = localeModules[path].default || localeModules[path];
  }
}

export default messages;
